<template>

		<el-main>
		        <el-tabs v-model="activeName" @tab-click="handleClick">
		            <el-tab-pane label="分组项目" name="item" >
		                <groupitem v-if="showitem" :inordergroup="OrderGroupEnt"></groupitem>
		            </el-tab-pane>
		    
		            <el-tab-pane label="分组加项包" name="itemadd">
		                <groupitemadd v-if="showitemadd" :inordergroup="OrderGroupEnt"></groupitemadd>    
		            </el-tab-pane>
		        </el-tabs>
		        
		    </el-main>

</template>

<script>
	import groupitem from './GroupItem.vue'
	import groupitemadd from './GroupItemAdd.vue'
	export default {
		created() {
			var ent = this.$route.query.ent;
			this.OrderGroupEnt = JSON.parse(ent);
		},
		watch: {
			// 如果路由发生变化，再次执行该方法
			"$route": "initData"
		},
		 components:{
		        groupitem,
		        groupitemadd
		    },
		    data() {
		        return {
					OrderGroupEnt:null,
		            //默认第一个选项卡
		            activeName: "item",
		            showitem:true,
		            showitemadd:false
		        }
		    },
		    mounted(){
		        
		    },
		    methods:{
				initData() {
					var ent = this.$route.query.ent;
					this.OrderGroupEnt = JSON.parse(ent);
					this.showitem =false ;
					this.showitemadd = false;
					this.$nextTick(() => {
					
					if(this.activeName == "item") {
					    this.showitem = true;
					} else  {
					    this.showitemadd = true;
					}
					});
					},
		        handleClick() {
		            if(this.activeName == "item") {
		                this.showitem = true;
		                this.showitemadd = false;
		            } else  {
		                this.showitem = false;
		                this.showitemadd = true;
		            }
		        }
		    }
	
	}
</script>
